import React from 'react';
import ImageComponent from 'atoms/Image';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const MeetColonelBanner = ({ data }) => {
  const { headline, noteLine, bg, fg } = data;
  const { file } = bg?.fields || fg?.fields;
  const heading = headline?.trim().split(' ');
  return (
    <div className='brand-page-banner d-flex align-items-center flex-column' data-testid='brand-page-banner'>
      <div className='strip-icon'>
        <ImageComponent srcFile={IMAGE_PATH?.StripesIcon} />
      </div>
      <div className='banner-container text-center d-flex align-items-center flex-column'>
        <h1 className='banner-heading-sm'>{heading?.slice(0, 2).join(' ')}</h1>
        <h1 className='banner-heading-lg'>{heading?.[2]}</h1>
        <div className='banner-short-desc'>{noteLine}</div>
      </div>
      <div className='banner-ribbon-icon'>
        <ImageComponent srcFile={file?.url} />
      </div>
    </div>
  );
};

export default MeetColonelBanner;
